import { ActionContextBasic } from '../index'
import { PageMsgInterface } from '@/interfaces/page'

export interface State {
  [key: string]: string;
  GoodsList: string;
  DealerList: string;
  SchoolList: string;
  OrderList: string;
  MemberList: string;
  RefundList: string;
}

const state = () => ({
  GoodsList: '',
  DealerList: '',
  SchoolList: '',
  OrderList: '',
  MemberList: '',
  RefundList: ''
})

const mutations = {
  STORE_PAGE (state: State, msg: PageMsgInterface) {
    const { page, options, filter } = msg
    state[page] = JSON.stringify({
      options,
      filter
    })
  },
  CLEAR_PAGE (state: State, routeName: string) {
    state[routeName] = ''
  }
}

const actions = {
  storePage: (context: ActionContextBasic, msg: PageMsgInterface) => {
    context.commit('STORE_PAGE', msg)
  },
  clearPage: (context: ActionContextBasic, routeName: string) => {
    context.commit('CLEAR_PAGE', routeName)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
